import * as React from 'react';
import { useState } from 'react';
import { Reference, Part } from '../../../redux/TaxonomyReferenceSlice';
import { useAppSelector, useAppDispatch } from '../../../hooks/index';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane, Nav, NavItem, NavLink, FormGroup, Input, FormFeedback, Container, Row, Col, Label, Toast, ToastHeader, ToastBody } from 'reactstrap';
import { Afr, getSelectedAfr } from '../../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../../redux/EntitySlice';
import { TaxonomyUpdate, TaxonomyUpdateReport, immediateUpdate, ReferenceInput, PartInput, ReferenceAssignmentInput } from '../../../redux/TaxonomyChangesSlice';
import { UserRoleEnum, selectUser, selectUserLogged } from '../../../redux/UserSlice';
import utilityHelper from '../../../utils/utilityHelper';


import './ModalPopUp.css';
import RatingReview from '../UserFeedback/RatingReview';

function AfrSubmissionSurvey(props: { entity: Entity, afr: Afr, proto: Reference, isOpen: any, onCloseModal: any, handleSubmitOrDecline : any }) {

    const dispatch = useAppDispatch();
    const [rating, setRating] = useState<number>(0);
    const [numTimes, setNumTimes] = useState<string>("");
    const [suggestions, setSuggestions] = useState<string>("");
    const [hadAssistance, setHadAssistance] = useState<boolean | null>(null);
    const [assistance, setAssistance] = useState<string>("");
    const loggedUser = useAppSelector(selectUserLogged);

    const handleNumTimesChange = function (event: any) {
       setNumTimes( event.target.value );
    }
    const leftMarginStyle = {
        marginLeft: '1em'
    }

    const getNumberAsText = function(value: number | null): string {
        return value ? value + "": "";
    }
    const createSurveyParts = function (refId : string, afr : Afr, declined : boolean): PartInput[] {
        var results: PartInput[] = [];

        props.proto.parts.map((part: Part) => {
            var pdName = part.definition.name;
            var pdValue = "";
            switch (pdName) {
                case "UASID":
                    pdValue = refId;
                    break;

                case "TaxonomyType":
                    pdValue = afr.taxonomyType ? afr.taxonomyType : "AFR";
                    break;

                case "FiscalYear":
                    pdValue = afr.year + "";
                    break;

                case "Quarter":
                    pdValue = afr.logicalPeriod ? afr.logicalPeriod : "ANNUAL";
                    break;

                case "Revision":
                    pdValue = afr.currentversion ? getNumberAsText(afr.currentversion.revisionNumber) : "";
                    break;

                case "Amendment":
                    pdValue = afr.currentversion ? getNumberAsText(afr.currentversion.amendmentNumber) : "";
                    break;

                case "UserName":
                    pdValue = loggedUser.login;
                    break;

                case "Declined":
                    pdValue = declined ? "true" : "false";
                    break;

                case "Rating":
                    pdValue = declined ? "" : rating + ""
                    break;

                case "NumberTimesFiled":
                    pdValue = declined ? "": numTimes + ""
                    break;

                case "Suggestions":
                    pdValue = declined ? "" : suggestions;
                    break;

                case "Assistance":
                    pdValue = (declined || hadAssistance === null ) ? "" :
                          hadAssistance === true ? assistance : "No";
                    break;

            }
            results.push({ partName: pdName, partValue: pdValue });
        });
        return results;
    }
    const handleSubmitOrDecline = function (declined: boolean) {
        var questions: any = {};
        if (!declined) {
            questions["Rating"] = rating + "";
            questions["NumberTimesFiled"] = numTimes + "";
            questions["Suggestions"] = suggestions;
            if (hadAssistance === null) {
                questions["Assistance"] = "";
            } else {
                if (hadAssistance === false) {
                    questions["Assistance"] = "No";
                } else {
                    questions["Assistance"] = assistance;
                }
            }

        }
        props.handleSubmitOrDecline(declined, questions);
        props.onCloseModal();
    }
    const handleSubmit = function () {
        handleSubmitOrDecline(false);
    }
    const handleDecline = function () {
        handleSubmitOrDecline(true);
    }
    const handleHadAssistanceChange = function (e: any) {
        switch (e.target.value) {
            case "TRUE":
                setHadAssistance(true);
                break;

            case "FALSE":
                setHadAssistance(false);
                break;

            default:
                setHadAssistance(null);
                break;
        }
    }

    const convertToEnum = function (entries: string[]): any[] {
        var result: any[] = [];
        entries.map((e: string) => {
            var kvPair: string[] = e.split("=");
            result.push({ label: kvPair[0], value: kvPair[1] } );
        });
        return result;
    }
    const paintQuestion = function (qPart : Part ) {
        var question: string = ""
        var qtype: string = "";
        var qtypeArgs: string = "";
        var qParts: string[] = qPart.definition.documentation.split(":");
        question = qParts[1];
        qtype = qParts[0];
        if (qtype.indexOf("(") > 0) {
            var parts = qtype.split("(");
            qtype = parts[0];
            qtypeArgs = parts[1].substring(0, parts[1].length - 1);
        }
        var render: boolean;
        var fixedupQuestion = question.replace("{afryear}", "" + props.afr.year) + "?";
        var jsxSection = <div></div>;
        switch (qtype.toUpperCase()) {
            case "RATING":
                jsxSection = <div key={question}>
                    <Row>
                        <Col>
                            <Label>{fixedupQuestion}</Label>
                            <RatingReview rating={rating} setRating={setRating} />
                        </Col>
                    </Row>
                </div>;
                break;

            case "ENUM":
                jsxSection = <div key={question}>
                    <Row>
                        <Col>
                            <Label>{fixedupQuestion}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <FormGroup>
                            <Row style={leftMarginStyle}>
                                <Col>
                                    {convertToEnum(qtypeArgs.split(",")).map((kv: any) => (
                                        <Row>
                                            <Label className="ml-4" check key={kv.value}>
                                                <Input type="radio"
                                                    name={kv.label}
                                                    value={kv.value}
                                                    onChange={handleNumTimesChange}
                                                    checked={(numTimes === kv.value)}
                                                /><b>{kv.label}</b>
                                            </Label>
                                        </Row>
                                    ))
                                    }
                                </Col>
                            </Row>
                        </FormGroup>
                    </Row>
                </div>;
                break;

            case "TEXT":
                jsxSection = <div key={question}>
                    <Row>
                        <Col>
                            <Label>{fixedupQuestion}</Label>
                            <Input type="textarea" value={suggestions}
                                onChange={(e) => setSuggestions(e.currentTarget.value)} />
                        </Col>
                    </Row>
                </div>;
                break;

            case "BOOLEANTEXT":
                jsxSection = <div key={question}>
                    <Row>
                        <Col>
                            <Label>{fixedupQuestion}</Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Label className="ml-4" check>
                                <Input type="radio"
                                    name="boolValue"
                                    value={"TRUE"}
                                    onChange={(e) => handleHadAssistanceChange(e)}
                                    checked={(hadAssistance !== null && hadAssistance === true) ? true : false}
                                /><b>Yes</b>
                            </Label>
                        </Col>
                        <Col>
                            <Label className="ml-4" check>
                                <Input type="radio"
                                    name="boolValue"
                                    value={"FALSE"}
                                    onChange={(e) => handleHadAssistanceChange(e)}
                                    checked={(hadAssistance !== null && hadAssistance === false) ? true : false}
                                /><b>No</b>
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input type="textarea" value={assistance} hidden={hadAssistance === null || hadAssistance === false}
                                onChange={(e) => setAssistance(e.currentTarget.value)} />
                        </Col>
                    </Row>
                </div>;
                break;
        }
        return jsxSection;
    }
    const questionParts = function (reference : Reference): Part[] {
        var result: Part[] = [];
        reference.parts.map((part: Part) =>
        {
            if (part.definition.documentation && (part.definition.documentation.indexOf(":") > 0)) {
                result.push(part);
            }
        });
        return result;
    }

    return (
        <React.Fragment >
            <Modal size="xl" isOpen={props.isOpen} onClose={props.onCloseModal}>
                <ModalHeader style={{ display: "flex", justifyContent: "center", width: "100%" }}>AFR Completion Survey</ModalHeader>
                <ModalBody>
                    {questionParts(props.proto).map((part: Part) => paintQuestion(part))}
                </ModalBody>
                <ModalFooter style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Button color="primary" onClick={handleSubmit}>Submit</Button>
                    <Button color="secondary" onClick={handleDecline}>Decline</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
}

export default AfrSubmissionSurvey;